var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md7":"","lg7":""}},[_c('GrossingByLabManagers',{attrs:{"data":_vm.grossingByLabManagersStats}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md5":"","lg5":""}},[_c('GlassesMicrotomed',{staticClass:"ml-5",attrs:{"data":_vm.glassesMicrotomedStats}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5202838","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Walldash/SecondScreen.vue
// module id = null
// module chunks = 